import React, { ChangeEvent, useState } from "react";
import {
  TextField,
  Typography,
  TextFieldProps,
  Popover,
  Box,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface FormFieldProps {
  label: string;
  placeholder: string;
  name: string;
  value?: string | number;
  defaultValue?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  typographySx?: React.CSSProperties;
  textFieldSx?: React.CSSProperties;
  InputProps?: TextFieldProps["InputProps"];
  multiline?: boolean;
  rows?: number;
  type?: string;
  infoText?: string;
  disabled?: boolean;
}

interface SearchBarProps {
  searchTerm?: string;
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  searchtext?: any;
}

export const FormField: React.FC<FormFieldProps> = ({
  type,
  label,
  disabled,
  infoText,
  placeholder,
  name,
  value,
  defaultValue,
  onChange,
  error,
  typographySx,
  textFieldSx,
  InputProps,
  multiline,
  rows,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event: any) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "info-popover" : undefined;

  const handleMouseEnter = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMouseLeave = () => {
    setAnchorEl(null);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "32%" }}>
      <Typography
        sx={{
          fontFamily: "Montserrat",
          fontSize: "14px",
          fontWeight: 600,
          lineHeight: "24px",
          letterSpacing: "0px",
          textAlign: "left",
          color: "#10383D",
          ...typographySx,
        }}
      >
        {label}
        {/* {infoText && <InfoOutlinedIcon sx={{marginLeft:'10px', fontSize: '13px', cursor:'pointer'}} aria-describedby={id} onClick={handleClick} />} */}

        {infoText && (
          <IconButton
            onMouseEnter={handleMouseEnter}
            // onMouseLeave={handleMouseLeave}
          >
            <InfoOutlinedIcon
              sx={{ marginLeft: "10px", fontSize: "13px", cursor: "pointer" }}
              aria-describedby={id}
            />
          </IconButton>
        )}
      </Typography>
      <TextField
        placeholder={placeholder}
        name={name}
        value={value === 0 ? 0 : value || defaultValue || ""}
        onChange={onChange}
        size="small"
        type={type}
        InputLabelProps={{
          shrink: false,
        }}
        error={!!error}
        disabled={disabled}
        helperText={error}
        sx={{
          ...textFieldSx,
          "& .MuiInputBase-root.Mui-disabled": {
            backgroundColor: "#f5f5f5", // whole field background
            borderRadius: "4px",
          },
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "#9e9e9e", // text color in Safari
            color: "#9e9e9e", // text color
            cursor: "not-allowed",
          },
        }}
        InputProps={InputProps}
        multiline={multiline}
        rows={multiline ? rows : undefined}
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 1, maxWidth: "auto" }}>
          <Typography sx={{ fontSize: "12px" }}>{infoText}</Typography>
        </Box>
      </Popover>
    </div>
  );
};

export const SearchBar: React.FC<SearchBarProps> = ({
  searchtext,
  onSearchChange,
  disabled,
}) => {
  return (
    <TextField
      id="outlined-basic"
      variant="outlined"
      placeholder={`Search ${searchtext ? `${searchtext}` : ""}`}
      // value={searchTerm}
      size="small"
      onChange={onSearchChange}
      disabled={disabled}
      InputProps={{
        startAdornment: <SearchIcon color="action" />,
      }}
      InputLabelProps={{
        shrink: false,
      }}
      sx={{
        padding: "8px, 16px",
        border: disabled ? "1px solid" : "1px",
        borderRadius: "4px",
        cursor: disabled ? "not-allowed" : "pointer",
        gap: "12px",
        minWidth: "180px",
        marginBottom: "4px",
      }}
    />
  );
};
